export default {
  category: 'book',
  name: 'Don’t Believe Everything You Think',
  author: 'Joseph Nguyen',
  date: '5/10/25',
  path: '/notes/dont-believe-everything-you-think',
  photo: 'https://twos.s3.amazonaws.com/parkerklein/parker-klein-dont-believe-everything-you-think-joseph-nguyen.jpg',
  tags: ['Self-help', 'Psychology', 'Health'],
  time: 26,
  rating: 8.5,
  review: '',
  link: 'https://www.amazon.com/Dont-Believe-Everything-You-Think/dp/B09WPP7R6S',
  mediumLink: '',
  patreonLink: '',
  // podcastLink: 'https://anchor.fm/parkerklein/episodes/',
  // podcastEmbed: 'https://anchor.fm/parkerklein/embed/episodes/',
  // youtubeLink: 'https://youtu.be/',
  twosLink: 'https://www.twosapp.com/681b6f93bce86e48f362ce95',
  // youtubeEmbed: 'https://www.youtube.com/embed/',
  releaseDate: '',
};
